import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { apiClient } from "../utils/const";

const DeleteUserButton = ({ userId, userName, onDeleteSuccess, cardNo = "" }) => {
  const [schemeType, setSchemeType] = useState(localStorage.getItem("schemeType"));

  // Listen for scheme changes
  useEffect(() => {
    const handleSchemeChange = (event) => {
      const newScheme = event.detail.to;
      setSchemeType(newScheme);
    };

    window.addEventListener("schemeChanged", handleSchemeChange);
    return () => window.removeEventListener("schemeChanged", handleSchemeChange);
  }, []);
  const handleDelete = () => {
    Swal.fire({
      title: `Are you sure you want to delete ${userName}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          user_id: userId,
          card_no: cardNo,
        };
        apiClient
          .post(
            schemeType === "kanchan"
              ? "kanchan/kanchan_delete_users.php"
              : "mandal/mandal_delete_users.php",
            payload
          )
          .then((res) => {
            // console.log("Delete user response", res.data);
            if (res.data?.message === "radha") {
              onDeleteSuccess(userId);
              Swal.fire("Deleted!", "User has been deleted.", "success");
            } else {
              Swal.fire("Error!", res.data?.message || "Something went wrong.", "error");
            }
          })
          .catch((err) => {
            console.error("Delete user error", err);
            Swal.fire("Error!", "Something went wrong.", "error");
          });
      }
    });
  };

  return (
    <button
      type="button"
      className="btn btn-outline-danger btn-sm"
      title="Delete User"
      onClick={handleDelete}
      data-user-id={userId}
      style={{
        borderRadius: "8px",
        padding: "6px 12px",
        transition: "all 0.2s ease",
        border: "1px solid #dc3545",
        color: "#dc3545",
        backgroundColor: "transparent",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#dc3545";
        e.currentTarget.style.color = "white";
        e.currentTarget.style.transform = "translateY(-1px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(220, 53, 69, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
        e.currentTarget.style.color = "#dc3545";
        e.currentTarget.style.transform = "translateY(0px)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <i className="fas fa-trash" style={{ fontSize: "0.8rem" }}></i>
    </button>
  );
};

export default DeleteUserButton;
